import {
  GHG_ESTIMATOR_CONCEPT_ID,
  IMPACT_CARRY_CONCEPT_ID,
  IMPACT_STRATEGY_CONCEPT_ID,
} from '~/constants/concepts'
import type { ImpactType } from '~/types/types'

/** Deep-link from a venture impact results card into the matching edit flow. */
export function impactResultCardEditPath(
  ventureId: string,
  impact?: Pick<ImpactType, 'id' | 'conceptId'> | null,
): string | null {
  if (!ventureId || impact?.id == null) return null

  const conceptId = Number(impact.conceptId)
  const base = `/${ventureId}/impact/edit/impacts/${impact.id}`

  if (conceptId === IMPACT_STRATEGY_CONCEPT_ID) {
    return `${base}/impactStrategy`
  }
  if (conceptId === IMPACT_CARRY_CONCEPT_ID) {
    return `${base}/impactCarry`
  }
  if (conceptId === GHG_ESTIMATOR_CONCEPT_ID) {
    return `${base}/define`
  }

  return `${base}/define`
}
